<template>
<div class="" style="background-color: #fff; 
    border-top: 1px solid #E7E7E7;">
    <div v-if="langluageType == 'ch'" class="col footer">
        <div class="link-list">
            <!-- <dl>
                <dt>热门推荐</dt>
                <dd><a href="https://www.expopaas.com/articlecrm" target="_blank">招展云</a></dd>
                <dd><a href="https://www.expopaas.com/articlepro" target="_blank">展装云</a></dd>
                <dd><a href="https://www.expopaas.com/articlework" target="_blank">主场云</a></dd>
            </dl> -->
            <dl>
                <dt>关于我们</dt>
                <dd><a href="/about">公司介绍</a></dd>
                <dd><a href="/about">团队介绍</a></dd>
                <dd><a href="/news">企业动态</a></dd>
            </dl>
            <dl>
                <dt>便捷入口</dt>
                <!-- <dd><a href="@@webRoot/page/activity.html">平台会员</a></dd> -->
                <!-- <dd><a href="http://shop.exposcm.com/" target="_blank">会展商城</a></dd> -->
                <dd><a href="https://www.exposcm.com/Article/index/category/zgxx.html" target="_blank">展馆信息</a></dd>
            </dl>
            <dl>
                <dt>友情链接</dt>
                <dd><a href="http://fms.mofcom.gov.cn/" target="_blank">商务部</a></dd>
                <dd><a href="https://www.ccpit.org/" target="_blank">贸促会</a></dd>
                <dd><a href="http://www.micecommittee.org.cn/" target="_blank">全国城贸联会展工作委员会</a></dd>
            </dl>
        </div>
        <div class="footer-r">
            <img src="../images/img-wx.png" alt="">
            <div class="text">
                <dl>
                    <dt>关注会展供应链公众号</dt>
                    <dd>获得更多服务信息</dd>
                </dl>
                <dl>
                    <dt>咨询热线</dt>
                    <dd style="font-size: 19px; line-height: 19px;">010-86460766-861</dd>
                </dl>
            </div>
        </div>
    </div>
    <div v-else class="col footer">
        <div class="link-list">
            <!-- <dl style="margin-right: 30px;">
                <dt style="margin-right:unset;">Hot Recommendations</dt>
                <dd style="margin-top: 12px;"><a href="https://www.exposaas.com/web/propaganda/articlecrm" target="_blank">Exhibiting Cloud</a></dd>
                <dd style="margin-top: 12px;"><a href="https://www.exposaas.com/web/propaganda/articlepro" target="_blank">Exhibition Cloud</a></dd>
                <dd style="margin-top: 12px;"><a href="https://www.exposaas.com/web/propaganda/articlework" target="_blank">Home Cloud</a></dd>
            </dl> -->
            <dl style="margin-right: 50px;">
                <dt style="margin-right:unset;">About Us</dt>
                <dd style="margin-top: 12px;"><a href="@@webRoot/page/about.html#p3">Platform Introduction</a></dd>
                <dd style="margin-top: 12px;"><a href="@@webRoot/page/about.html#p6">Team</a></dd>
                <dd style="margin-top: 12px;"><a href="@@webRoot/page/news.html?type=qydt">Enterprise Dynamics</a></dd>
            </dl>
            <dl style="margin-right: 50px;">
                <dt style="margin-right:unset;">Convenient Entrance</dt>
                <!-- <dd style="margin-top: 12px;"><a href="@@webRoot/page/activity.html">Membership</a></dd> -->
                <!-- <dd style="margin-top: 12px;"><a href="http://shop.exposcm.com/" target="_blank">Exhibition Mall</a></dd> -->
                <dd style="margin-top: 12px;"><a href="https://www.exposcm.com/Article/index/category/zgxx.html" target="_blank">Pavilion Information</a></dd>
            </dl>
            <dl>
                <dt style="margin-right:unset;">Friendly Links</dt>
                <dd style="margin-top: 12px;"><a href="http://fms.mofcom.gov.cn/" target="_blank">Ministry of Commerce</a></dd>
                <dd style="margin-top: 12px;"><a href="https://www.ccpit.org/" target="_blank">CCPIT</a></dd>
                <dd style="margin-top: 12px;"><a href="http://www.micecommittee.org.cn/" target="_blank">All-China Federation of Trade and Industry<br/> Exhibition Working Committee</a></dd>
            </dl>
        </div>
        <div class="footer-r">
            <img src="../images/img-wx.png" alt="">
            <div class="text">
                <dl>
                    <dt style="margin-right:unset;">Follow EXPOSCM</dt>
                    <dd>Get more service information</dd>
                </dl>
                <dl>
                    <dt style="margin-right:unset;">Hotline</dt>
                    <dd style="font-size: 19px; line-height: 19px;">010-86460766-861</dd>
                </dl>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="icpn">
            <span>Copyright©2022&emsp;&emsp;ExpoSCM | 会展供应链</span>
            <p>
                ICP证 京B2-20171371&emsp;&emsp;
                <a href="https://beian.miit.gov.cn" target="_blank" style="color: #909399;">京ICP备 17015357号-1</a>&emsp;&emsp;
                <img style="width: 15px; vertical-align: sub;" src="../images/icon-ba.png" alt=""> 
                <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502034153" target="_blank" style="color: #909399;">京公网安备 11010502034153</a>
            </p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data() {
      return {
        langluageType:sessionStorage.getItem('langluageType')||'ch'
      };
    },
    mounted() {
  
    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/common/Footer.vue